import React from 'react';
import MuiAvatar from '@mui/material/Avatar';

type Props = {
  size?: 'large' | 'default' | 'small';
} & React.ComponentProps<typeof MuiAvatar>

export default function Avatar({ size = 'default', ...others }: Props): React.ReactElement {
  const spacing = size === 'default' ? 5 : (size === 'small' ? 3 : 7);

  return (
    <MuiAvatar
      sx={{ width: (theme) => theme.spacing(spacing), height: (theme) => theme.spacing(spacing) }}
      {...others}
    />
  );
}
